import { render, staticRenderFns } from "./ChallengeItem.vue?vue&type=template&id=0ee03dd3&scoped=true"
import script from "./ChallengeItem.vue?vue&type=script&lang=ts"
export * from "./ChallengeItem.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeItem.vue?vue&type=style&index=0&id=0ee03dd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee03dd3",
  null
  
)

export default component.exports